import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderStatusRequestImplEncoder } from "../../encoder/OrderStatusRequestImplEncoder";

import * as CubiqTS from "../../index";
import { OrderStatusRequest } from "../OrderStatusRequest";

export class OrderStatusRequestImpl extends ConcreteEncodable implements OrderStatusRequest {
  public static enType: string = "com.bcdfx.model.event.OrderStatusRequestImpl";

  /*FID=1*/
  public accountCode: string;
  /*FID=2*/
  public branchCds: Array<string> | null = null;
  /*FID=3*/
  public ccyPairs: Array<string> | null = null;
  /*FID=4*/
  public clientCode: string;
  /*FID=5*/
  public entryComparitor: CubiqTS.DateComparitor | null = null;
  /*FID=6*/
  public entryUserCd: string;
  /*FID=7*/
  public expiryComparitor: CubiqTS.DateComparitor | null = null;
  /*FID=8*/
  public fillComparitor: CubiqTS.DateComparitor | null = null;
  /*FID=9*/
  public orderId: string;
  /*FID=10*/
  public orderIds: Array<string> | null = null;
  /*FID=11*/
  public orderStates: Array<CubiqTS.OrderStateFilter> | null = null;
  /*FID=12*/
  public orderTypes: Array<CubiqTS.RequestOrderType> | null = null;
  /*FID=13*/
  public products: Array<CubiqTS.Product> | null = null;
  /*FID=14*/
  public salesGroupIds: Array<CubiqTS.Long> | null = null;
  /*FID=15*/
  public lastUpdateComparitor: CubiqTS.DateComparitor | null = null;
  /*FID=16*/
  public oboEntryUser: string;
  /*FID=17*/
  public oboAccount: string;
  /*FID=18*/
  public oboClient: string;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  /*FID=99999*/
  public con: CubiqTS.Condition;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderStatusRequestImplEncoder.Instance;
    this.setEncodableType(OrderStatusRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "OrderStatusRequestImpl[" +
      "accountCode=" +
      this.accountCode +
      "branchCds=" +
      this.branchCds +
      "ccyPairs=" +
      this.ccyPairs +
      "clientCode=" +
      this.clientCode +
      "entryComparitor=" +
      this.entryComparitor +
      "entryUserCd=" +
      this.entryUserCd +
      "expiryComparitor=" +
      this.expiryComparitor +
      "fillComparitor=" +
      this.fillComparitor +
      "orderId=" +
      this.orderId +
      "orderIds=" +
      this.orderIds +
      "orderStates=" +
      this.orderStates +
      "orderTypes=" +
      this.orderTypes +
      "products=" +
      this.products +
      "salesGroupIds=" +
      this.salesGroupIds +
      "lastUpdateComparitor=" +
      this.lastUpdateComparitor +
      "oboEntryUser=" +
      this.oboEntryUser +
      "oboAccount=" +
      this.oboAccount +
      "oboClient=" +
      this.oboClient +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "con=" +
      this.con +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
